import React from "react";
import styles from './ContactUs.module.css';

interface Props {
    name: string,
    value?: string,
    label?: string,
    placeholder?: string,
    onInputChange: Function,
    required?: boolean,
    type?: string,
    showText?: boolean
}

const TextInput = ({ name, label, placeholder, onInputChange, value, required, type, showText = true }: Props) => {
    return <label className={styles.TextInputLabel} htmlFor={name}>{showText ? label : ''}
        <input className={styles.TextInputElement} autoComplete={placeholder} id={name} type={type} name={name} value={value} placeholder={placeholder} onChange={(e) => onInputChange ? onInputChange(e.target.value) : null} required={required} />
    </label>
}

export default TextInput;